module.exports = __webpack_public_path__ + "static/img/documento_confirmacao.68403f02.svg";